// ** Initial State
const initialState = {
  data: [],
  selectedNewsLetterLogo: null,
};

const newsletterLogo = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_NEWSLETTERLOGOS':
      return {
        ...state,
        data: action.data,
      };
    case 'GET_NEWSLETTERLOGO':
      return {
        ...state,
        selectedNewsLetterLogo: action.selectedNewsLetterLogo,
      };
    case 'ADD_NEWSLETTERLOGO':
      return { ...state, selectedNewsLetterLogo: action.selectedNewsLetterLogo };
    case 'UPDATE_NEWSLETTERLOGO':
      return { ...state };
    case 'DELETE_NEWSLETTERLOGO':
      return { ...state };
    default:
      return { ...state };
  }
};

export default newsletterLogo;
